/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './asset-multi-settings-widget.scss';

/* eslint-disable import/no-unresolved, import/default */

import assetMultiSettingsWidgetTemplate from './asset-multi-settings-widget.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.assetMultiSettingsWidget', [])
    .directive('agAssetMultiSettingsWidget', AssetMultiSettingsWidget)
    .name;

/*@ngInject*/
function AssetMultiSettingsWidget() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: AssetMultiSettingsWidgetController,
        controllerAs: 'vm',
        templateUrl: assetMultiSettingsWidgetTemplate
    }
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function AssetMultiSettingsWidgetController($scope, $q, $mdDialog, $translate, $filter, types, agTypes, agUtils, userService, attributeService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.loading = false;

    vm.emptySettings = {};
    vm.multiSettings = {};

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.helpPageAction = agUtils.createHelpActionConfig("agMultiAssetSettings");

    vm.save = save;

    $scope.$watch('vm.ctx', function () {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.widgetTitle = $translate.instant('ag.asset.multi-settings');
            agUtils.getCropNames().then(
                (response) => {
                    vm.cropNames = [];
                    var cropNames = response.jsonValue;
                    for (var property in cropNames) {
                        var cropNameObj = {};
                        cropNameObj.nameId = property;
                        cropNameObj.value = cropNames[property];
                        vm.cropNames.push(cropNameObj);
                    }
                }
            );
        }
    });

    $scope.$on('multiSettingsSelectedAssets', function(event, selectedAssetsInfo) {
        vm.silosWithMoistureCables = [];
        vm.silosWithCO2Cables = [];
        vm.selectedAssetType = selectedAssetsInfo.selectedAssetType;
        vm.selectedAssets = selectedAssetsInfo.selectedAssets;
        vm.ctx.widgetTitle = vm.selectedAssets.length ? $translate.instant('ag.asset.multi-settings') + ': ' + vm.selectedAssets[0].typeName : $translate.instant('ag.asset.multi-settings');
        vm.silosWithMoistureCables =  $filter('filter')(vm.selectedAssets, {hasMoistureCables: true});
        vm.silosWithCO2Cables =  $filter('filter')(vm.selectedAssets, {hasCO2Cables: true});
        if (!vm.selectedAssets.length) {
            resetForm();
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
        }
    });

    function save($event) {
        var title = $translate.instant('ag.asset.update-multi-asset-title', {count: vm.selectedAssets.length}, 'messageformat');
        var content = $translate.instant('ag.asset.update-multi-asset-text');
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title(title)
            .htmlContent(content)
            .ariaLabel(title)
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(() => {
            vm.loading = true;
            var saveAttrTasks = [];
            var basicAttributes = [];
            basicAttributes.push({key: 'maxTemperature', value: vm.multiSettings.maxTemperature});
            basicAttributes.push({key: 'maxDeltaTemperature', value: vm.multiSettings.maxDeltaTemperature});
            basicAttributes.push({key: 'disableAlarms', value: vm.multiSettings.disableAlarms});
            var moistureAttributes = angular.copy(basicAttributes);
            if (vm.silosWithMoistureCables.length) {
                moistureAttributes.push({key: 'maxMoisture', value: vm.multiSettings.maxMoisture});
                moistureAttributes.push({key: 'maxDeltaMoisture', value: vm.multiSettings.maxDeltaMoisture});
            }
            var co2Attributes = angular.copy(moistureAttributes);
            if (vm.silosWithCO2Cables.length) {
                co2Attributes.push({key: 'maxCO2', value: vm.multiSettings.maxCO2});
                co2Attributes.push({key: 'maxDeltaCO2', value: vm.multiSettings.maxDeltaCO2});
            }

            for (var i = 0; i < vm.selectedAssets.length; i++) {
                var currentAttributes = basicAttributes;
                if (vm.selectedAssets[i].hasMoistureCables) {
                    currentAttributes = moistureAttributes
                }
                if (vm.selectedAssets[i].hasCO2Cables) {
                    currentAttributes = co2Attributes
                }

                saveAttrTasks.push(attributeService.saveEntityAttributes(vm.selectedAssets[i].id.entityType, vm.selectedAssets[i].id.id,
                    types.attributesScope.server.value, currentAttributes));
                saveAttrTasks.push(attributeService.saveEntityTimeseries(vm.selectedAssets[i].id.entityType, vm.selectedAssets[i].id.id,
                    "scope",[{key :agTypes.telemetry.silo.cropType, value: vm.multiSettings.cropType ? vm.multiSettings.cropType.nameId : "none"}]));
            }
            $q.all(saveAttrTasks).then(() => {
                vm.loading = false;
            },() => {
                vm.loading = false;
            });
        });
    }

    function resetForm() {
        vm.multiSettings = angular.copy(vm.emptySettings);
    }
}